import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import { renderInfoForType } from '../../../../utils/helpers';
import CustomFieldDetail from '../../../../components/customFields/CustomFieldDetail';
import Loading from '../../../../components/loading';
import styles from './forms.module.scss';
import Clickable from '../../../../components/clickable/Clickable';

class Forms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingStatus: false
    };
  }

  render() {
    const { loadingStatus } = this.state;
    const { formDetails, tileName, location, mapStyle, enableForm, handelFullScreen, fullScreenMode } = this.props;
    const renderWeatherObs = obs => (obs !== undefined
      ? `${obs.metar.summary} - ${obs.metar.temperature}${obs.metar.wind !== undefined ? `, ${obs.metar.wind}` : ''
      }${obs.metar.humidity !== undefined
        ? `, Humidity - ${obs.metar.humidity}`
        : ''
      }`
      : '');
    return (
      <Fragment>
        <Loading status={loadingStatus} />
        <Col lg={12} className={styles.cardHeight}>
          {enableForm
            && (
              <Card className={styles.formCard} style={{ height: fullScreenMode?'100vh': '', width: fullScreenMode?'100vw': '' }}>
                <div className="drag-handle">
                  <CardTitle className={styles.airfieldscardtitle}>
                    <Col lg={12}>
                      <Row>
                        <Col>
                          <FormattedMessage
                            id="airfieldconditionreport.tilename"
                            defaultMessage="{tileName}"
                            values={{ tileName }}
                          />
                        </Col>
                        <Col lg={3}>
                          {!fullScreenMode && (
                            <Clickable onClick={() => { handelFullScreen(true, 6); }}>
                              <p style={{ fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', justifyContent: 'flex-end' }}>
                                <FullscreenIcon />
                              </p>
                            </Clickable>
                          )}
                          {fullScreenMode && (
                            <Clickable onClick={() => { handelFullScreen(false, 6); }}>
                              <p style={{ fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', justifyContent: 'flex-end' }}>
                                X
                              </p>
                            </Clickable>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </CardTitle>
                </div>
                <hr className={styles.hrLine} />
                <CardBody className={styles.formCardBody}>
                  <Col lg={12} className={styles.formcard}>
                    <Fragment>
                      <div className={styles.container}>
                        <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
                          <div className={styles.infoHalf} style={{ borderTop: '1px solid #e6eaee' }}>
                            <span>
                              <FormattedMessage
                                id="forms.step2.created_by"
                                defaultMessage="Created By"
                              />
                            </span>
                            <p>{formDetails?.created_by?.fullname || ''}</p>
                          </div>
                          <div className={styles.infoHalf} style={{ borderTop: '1px solid #e6eaee' }}>
                            <span>
                              <FormattedMessage
                                id="forms.step2.created_date"
                                defaultMessage="Created Date"
                              />
                            </span>
                            <p>
                              {renderInfoForType({ type: 'datetime' }, formDetails?.form_date, null, null)}
                            </p>
                          </div>
                          {formDetails?.weather_conditions?.current_obs && (
                            <div key="weather_obs" className={styles.infoFull}>
                              <span>
                                <FormattedMessage
                                  id="inspections.answer_details.weatherobservation"
                                  defaultMessage="Weather Observations"
                                />
                              </span>
                              <div
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                  __html: renderWeatherObs(
                                    formDetails?.weather_conditions?.current_obs
                                  )
                                }}
                              />
                            </div>
                          )}
                        </div>
                        <CustomFieldDetail
                          data={formDetails?.data}
                          version={formDetails?.form_version}
                          fields={formDetails?.form_version?.schema?.fields}
                          location={location}
                          mapStyle={mapStyle}
                        />
                      </div>
                      <div className={styles.bottomStyle} />
                    </Fragment>
                  </Col>
                </CardBody>
              </Card>
            )
          }
        </Col>
      </Fragment>
    );
  }
}

Forms.propTypes = {
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Forms));
